var map = {
	"./EveryoneDao.png": 2241,
	"./FitnessBlockchain.png": 9481,
	"./Muso.png": 9941,
	"./PersonalWebsite.png": 7327,
	"./RateBCResaurants.png": 1271,
	"./RateBCResaurants1.png": 5550,
	"./SimCity.png": 3869,
	"./avatar.png": 8308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;